var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{staticClass:"mysnackbar",attrs:{"color":_vm.color,"timeout":_vm.timeout},model:{value:(_vm.showSnackbar),callback:function ($$v) {_vm.showSnackbar=$$v},expression:"showSnackbar"}},[_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.text)+" ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.showSnackbar = false}}},[_vm._v("\n    HIDE\n  ")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ce00664","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/snackbar.vue
// module id = null
// module chunks = 